/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FamilyHistoryResponseDto,
  UpsertFamilyHistoryRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FamilyHistoryResponseDtoFromJSON,
    FamilyHistoryResponseDtoToJSON,
    UpsertFamilyHistoryRequestDtoFromJSON,
    UpsertFamilyHistoryRequestDtoToJSON,
} from '../models/index';

export interface GetFamilyHistoryByPatientIdRequest {
    patientId: string;
}

export interface UpsertFamilyHistoryRequest {
    upsertFamilyHistoryRequestDto: UpsertFamilyHistoryRequestDto;
}

export interface UpsertFamilyHistoryByPatientIdRequest {
    patientId: string;
    upsertFamilyHistoryRequestDto: UpsertFamilyHistoryRequestDto;
}

/**
 * 
 */
export class PatientsFamilyHistoryApi extends runtime.BaseAPI {

    /**
     * Get patient\'s family history
     */
    async getFamilyHistoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyHistoryResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/family-history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s family history
     */
    async getFamilyHistory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyHistoryResponseDto> {
        const response = await this.getFamilyHistoryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s family history by patient ID
     */
    async getFamilyHistoryByPatientIdRaw(requestParameters: GetFamilyHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getFamilyHistoryByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/family-history/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s family history by patient ID
     */
    async getFamilyHistoryByPatientId(requestParameters: GetFamilyHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyHistoryResponseDto> {
        const response = await this.getFamilyHistoryByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s family history
     */
    async upsertFamilyHistoryRaw(requestParameters: UpsertFamilyHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyHistoryResponseDto>> {
        if (requestParameters['upsertFamilyHistoryRequestDto'] == null) {
            throw new runtime.RequiredError(
                'upsertFamilyHistoryRequestDto',
                'Required parameter "upsertFamilyHistoryRequestDto" was null or undefined when calling upsertFamilyHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/family-history`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertFamilyHistoryRequestDtoToJSON(requestParameters['upsertFamilyHistoryRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create patient\'s family history
     */
    async upsertFamilyHistory(requestParameters: UpsertFamilyHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyHistoryResponseDto> {
        const response = await this.upsertFamilyHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s family history by patient ID
     */
    async upsertFamilyHistoryByPatientIdRaw(requestParameters: UpsertFamilyHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertFamilyHistoryByPatientId().'
            );
        }

        if (requestParameters['upsertFamilyHistoryRequestDto'] == null) {
            throw new runtime.RequiredError(
                'upsertFamilyHistoryRequestDto',
                'Required parameter "upsertFamilyHistoryRequestDto" was null or undefined when calling upsertFamilyHistoryByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/family-history/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertFamilyHistoryRequestDtoToJSON(requestParameters['upsertFamilyHistoryRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create patient\'s family history by patient ID
     */
    async upsertFamilyHistoryByPatientId(requestParameters: UpsertFamilyHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyHistoryResponseDto> {
        const response = await this.upsertFamilyHistoryByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
